import React from 'react';
var ListContext = /*#__PURE__*/React.createContext(null);
export default ListContext;